import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块,post数据需要qs格式化
import base from './base'// 导入接口域名列表
//相关接口
;

const myAllWork = {
  //列表数据
  getPage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/zmPlanUser/page`, params);
  },
  //列表数据
  getPageByPartner(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/zmPlanUser/pageByPartner`, params);
  },
  //根据id查询单个信息
  getById(params) {
    return axios.get(`${base.bs}/admin/zmPlanUser/get/${params.id}`)
  },
  //保存修改
  saveOrUpdate(params) {
    return axios.post(`${base.bs}/admin/zmPlanUser/set`, params)
  },
  //根据id删除单个
  del(params) {
    return axios.get(`${base.bs}/admin/zmPlanUser/del/${params.id}`)
  },
  //批量删除
  batchDel(params) {
    return axios.get(`${base.bs}/admin/zmPlanUser/batchDel?ids=${params.ids}`,null)
  },
  //批量删除
  gl(params) {
    return axios.post(`${base.bs}/admin/zmPlanUser/gl`,params)
  },
  //读取报名的演员
  getListOfMap(params) {
    return axios.post(`${base.bs}/admin/zmPlanUser/getListOfMap/${params.planid}`, {yyid:params.yyid,bmstatus:params.bmstatus})
  },
}
// 导出接口
export default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/tabZmPlanUser.js